// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "bundle." + chunkId + "." + "13a83de7eaa2f2f80548b83081b115cd" + ".js";
};